export default {
  palette: {
    primary: {
      light: "#ABC200",
      main: "#333333",
      dark: "#000000",
      contrastText: "#696969",
      // contrastText: '#7f7f7f'
    },
    secondary: {
      light: "#FFFFFF",
      main: "#F2F2F2",
      dark: "#212121",
      contrastText: "#646464",
    },
    // error: will use the default color
  },
  typography: {
    useNextVariants: true,
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "Roboto",
      "Raleway",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "2px",
        transition: "all 200ms ease-in",
        "&$raisedPrimary": {
          backgroundColor: "#ABC200",
          color: "#FFFFFF",
        },
        "&$raisedPrimary:hover": {
          backgroundColor: "#92A501",
        },
        "&$raisedSecondary:hover": {
          backgroundColor: "rgb(227, 227, 227)",
        },
        "&$flatSecondary": {
          color: "#646464",
        },
        "&$flatSecondary:hover": {
          backgroundColor: "#e3e3e3",
        },
        "&$flatPrimary": {
          color: "#ABC200",
        },
        "&$flatPrimary:hover": {
          backgroundColor: "#e3e3e3",
        },
        "&$disabled": {
          opacity: 0.45,
        },
      },
    },
    MuiFab: {
      root: {
        transition: "all 200ms ease-in",
        "&$primary": {
          backgroundColor: "#ABC200",
          color: "#FFFFFF",
        },
        "&$primary:hover": {
          backgroundColor: "#92A501",
        },
        "&$secondary:hover": {
          backgroundColor: "rgb(227, 227, 227)",
        },
        "&$disabled": {
          opacity: 0.45,
        },
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: "unset",
      },
    },
    MuiList: {
      root: {
        backgroundColor: "#242424",
      },
    },
    MuiListItem: {
      root: {
        fontFamily: "Roboto !important",
        fontSize: "11px !important",
        fontWeight: "400 !important" as any,
        color: "#e2e2e3 !important",

        "&$selected:focus": {
          backgroundColor: "#697513 !important",
        },
      },
    },
    MuiInput: {
      root: {
        "&$focused": {
          "&:hover:not($disabled):not($focused):not($error):before": {
            borderBottom: "2px solid red !important",
          },
        },
      },
      underline: {
        "&:before": {
          borderBottom: "1px solid #757476 !important",
        },
        "&:after": {
          borderBottom: "2px solid #757476",
        },
        "&:hover:not($disabled):not($focused):not($error):before": {
          borderBottom: "2px solid #757476",
        },
      },
      formControl: {
        marginTop: "12px !important",
      },
      input: {
        fontFamily: "Roboto !important",
        fontSize: "11px !important",
        fontWeight: "400 !important" as any,
        color: "#e2e2e3 !important",
      },
    },

    MuiSelect: {
      select: {
        fontFamily: "Roboto !important",
        fontSize: "11px !important",
        fontWeight: "400 !important" as any,
        color: "#e2e2e3 !important",
      },
      icon: {
        color: "#fff !important",
      },
    },
    MuiInputLabel: {
      root: {
        fontFamily: "Raleway !important",
        fontSize: "12px !important",
        fontWeight: "700 !important" as any,
        color: "#abaaac !important",
        textTransform: "uppercase" as any,
        letterSpacing: "2px",
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: "2px",
        backgroundColor: "#2F2F2F",
      },
    },
    MuiDialogTitle: {
      root: {
        backgroundColor: "#272727",
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: 500,
        borderBottom: "1px solid black",
        padding: "20px",
        color: "#f2f2f2",
      },
    },
    MuiDialogContent: {
      root: {
        fontFamily: "Roboto",
        fontSize: "16px",
        fontWeight: 400,
        padding: "20px",
        color: "#a6a6a6",
      },
    },
    MuiContainer: {
      minWidth: "1024px",
    },
    MuiRadio: {
      root: {
        color: "#757476",
        "&$checked": {
          color: "#ABC200 !important",
        },
      },
    },
    MuiSlider: {
      thumb: {
        backgroundColor: "#ABC200 !important",
      },
      trackBefore: {
        backgroundColor: "#ABC200 !important",
      },
      trackAfter: {
        backgroundColor: "#4c4b50 !important",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/project/components/pages/ProjectTheme.tsx